// src/services/notesService.js
import api from './api'; // Your axios instance

const notesService = {
  // Get all notes
  getAllNotes: async (params = {}) => {
    const response = await api.get('/v1/notes', { params });
    return response.data;
  },

  // Get single note
  getNote: async (id) => {
    const response = await api.get(`/v1/notes/${id}`);
    return response.data;
  },

  // Create note
  createNote: async (noteData) => {
    const response = await api.post('/v1/notes', noteData);
    return response.data;
  },

  // Update note
  updateNote: async (id, noteData) => {
    const response = await api.put(`/v1/notes/${id}`, noteData);
    return response.data;
  },

  // Delete note
  deleteNote: async (id) => {
    const response = await api.delete(`/v1/notes/${id}`);
    return response.data;
  },

  // Toggle favorite
  toggleFavorite: async (id) => {
    const response = await api.patch(`/v1/notes/${id}/favorite`);
    return response.data;
  },

  // Toggle archive
  toggleArchive: async (id) => {
    const response = await api.patch(`/v1/notes/${id}/archive`);
    return response.data;
  },

  // Share note
  shareNote: async (id, shareData) => {
    const response = await api.post(`/v1/notes/${id}/share`, shareData);
    return response.data;
  },

  // Remove share
  removeShare: async (id, userId) => {
    const response = await api.delete(`/v1/notes/${id}/share`, { data: { userId } });
    return response.data;
  },

  // Summarize note with AI
  summarizeNote: async (id) => {
    const response = await api.post(`/v1/notes/${id}/summarize`);
    return response.data;
  },

  // Upload a file and create a new note or replace content of an existing note
  uploadNote: async (file, noteId = null) => {
    console.log('uploadNote called with file:', file, 'noteId:', noteId);
    const formData = new FormData();
    formData.append('file', file);
    if (noteId) formData.append('noteId', noteId);
    console.log('FormData created, sending request...');

    const response = await api.post('/v1/notes/upload', formData, {
      headers: {
        'Content-Type': undefined, // Let axios set the Content-Type with boundary
      },
    });
    return response.data;
  },

  // Search notes
  searchNotes: async (query, params = {}) => {
    const response = await api.get('/v1/notes/search', {
      params: { q: query, ...params }
    });
    return response.data;
  },

  // Get clusters
  getClusters: async () => {
    const response = await api.get('/v1/notes/clusters');
    return response.data;
  },

  // Update cluster
  updateCluster: async (noteId, cluster) => {
    const response = await api.patch(`/v1/notes/${noteId}/cluster`, { cluster });
    return response.data;
  },
};

export default notesService;
